import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "trezo-card bg-purple-200 dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md relative" }
const _hoisted_2 = { class: "trezo-card-content pb-[81px]" }
const _hoisted_3 = { class: "absolute -bottom-[42px] md:-bottom-[37px] ltr:-left-[12px] rtl:-right-[12px] ltr:-right-[10px] rtl:-left-[10px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "block" }, " Overall Visitors ", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "mb-0 flex items-center font-medium text-xl mt-[11px]" }, [
        _createTextVNode(" 45,745 "),
        _createElementVNode("span", { class: "relative font-medium text-xs inline-block text-success-700 bg-success-100 border border-success-300 py-[1.5px] ltr:pl-[22px] rtl:pr-[22px] ltr:pr-[10px] rtl:pl-[10px] rounded-full ltr:ml-[10px] rtl:mr-[10px]" }, [
          _createElementVNode("i", { class: "ri-arrow-up-fill absolute ltr:left-[6px] rtl:right-[6px] text-base top-1/2 -translate-y-1/2 mt-px" }),
          _createTextVNode(" 7% ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "area",
              height: "160",
              options: _ctx.overallVisitors,
              series: _ctx.visitors
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}